module.exports = __webpack_public_path__ + "img/correct.7d5501b1.png";